// extracted by css-extract-rspack-plugin
export default {"root":"VVQcdwBZUEET0D0C"};